<template>
<div>
    <HeaderContent header="ตั้งค่าเว็บไซต์" :img_header="header_image" link_back="content" />
    <MenuContentSetting />
    <ContentAboutList />
</div>
</template>

<script>
import HeaderImage from '@/assets/settings.png'
import HeaderContent from '@/components/menuadmin/content/contentheader/HeaderContent.vue'
import MenuContentSetting from '@/components/menuadmin/content/contentsetting/MenuContentSetting.vue'
import ContentAboutList from '@/components/menuadmin/content/contentsetting/ContentAboutList.vue'

export default {
    name: 'contentAbout',
    components: {
        HeaderContent,
        MenuContentSetting,
        ContentAboutList,
    },
    data() {
        return {
            header_image: HeaderImage
        }
    }
}
</script>
